/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

import { PreviewBlock } from './PreviewBlock';

export default PreviewBlock;

/**
 * @deprecated Use `import { PreviewBlock } from '@atlaskit/smart-card/preview-block'` instead.
 */
export { PreviewBlock } from './PreviewBlock';
